<template>
  <div>
    <hr />
    <b-row class="my-3 justify-content-center"
      ><h5>Restaurant Attributes</h5></b-row
    >
    <b-row class="my-3 justify-content-center">
      <b-col cols="6" lg="2">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in options1"
            v-model="selected"
            :key="option.value"
            :value="option.value"
            :aria-describedby="ariaDescribedby"
            size="lg"
            name="flavour-3a"
            class="py-3"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="6" lg="2">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in options2"
            v-model="selected"
            :key="option.value"
            :value="option.value"
            :aria-describedby="ariaDescribedby"
            name="flavour-3a"
            size="lg"
            class="py-3"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group></b-col
      >
      <b-col cols="6" lg="2">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in options3"
            v-model="selected"
            :key="option.value"
            :value="option.value"
            :aria-describedby="ariaDescribedby"
            name="flavour-3a"
            size="lg"
            class="py-3"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group></b-col
      >
      <b-col cols="6" lg="2">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-for="option in options4"
            v-model="selected"
            :key="option.value"
            :value="option.value"
            :aria-describedby="ariaDescribedby"
            name="flavour-3a"
            size="lg"
            class="py-3"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group></b-col
      >
      <b-col cols="12" lg="2">
        <b-form-group v-slot="{ ariaDescribedby }">
          <!-- Alcohol -->
          <b-form-checkbox
            v-for="option in options5"
            v-model="selected"
            :key="option.value"
            :value="option.value"
            :aria-describedby="ariaDescribedby"
            class="py-3"
            size="lg"
            name="flavour-3a"
          >
            {{ option.text }}
          </b-form-checkbox>

          <!-- Radio Buttons -->
          <b-form-group
            :class="selected.includes('Alcohol') ? 'd-block' : 'd-none'"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio
              v-model="selectedAlcohol"
              :aria-describedby="ariaDescribedby"
              class="py-2 ml-4"
              name="some-radios"
              value="FullBar"
              
              >Full Bar</b-form-radio
            >
            <b-form-radio
              v-model="selectedAlcohol"
              :aria-describedby="ariaDescribedby"
              class="py-2 ml-4"
              name="some-radios"
              
              value="BeerAndWineOnly"
              >Bear & Wine</b-form-radio
            >
          </b-form-group>
        </b-form-group>

        <!-- BYOB checkbox -->
        <b-form-checkbox
          v-for="option in options6"
          v-model="selected"
          :key="option.value"
          :value="option.value"
          class="py-3 mt-4"
          size="lg"
          name="flavour-3a"
        >
          {{ option.text }}
        </b-form-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as types from "@/store/types";
import { mapGetters } from "vuex";
export default {
  name: "restaurantAttributes",

  data() {
    return {
      selected: [""],
      options1: [
        { text: "Breakfast", value: "Breakfast" },
        { text: "Lunch", value: "Lunch" },
        { text: "Dinner", value: "Dinner" },
        { text: "Brunch", value: "Brunch" },
        { text: "Snack", value: "Snack" },
      ],

      options2: [
        { text: "Delivery", value: "Delivery" },
        { text: "Takeout", value: "TakeOut" },
        { text: "Catering", value: "Catering" },
        { text: "Banquet", value: "Banquet" },
      ],

      options3: [
        { text: "Reservations", value: "TakeReservations" },
        { text: "Happy Hours", value: "HappyHours" },
        { text: "Outdoor Seats", value: "OutdoorSeating" },
        { text: "Parking", value: "FreeParking" },
      ],

      options4: [
        { text: "Free Wifi", value: "WiFi" },
        { text: "TV", value: "HasTV" },
      ],

      options5: [{ text: "Alcohol Served", value: "Alcohol" }],

      options6: [{ text: "BYOB", value: "BYOB" }],

      selectedAlcohol: "",

      businessProfile: {},
      restaurantAttributes: {},
      sendRequest: false,
    };
  },
  computed: {
    ...mapGetters([
      "businessProfileGetter",
      // ...
    ]),
  },
  watch: {
    selected: function() {
      if (this.sendRequest) {
        this.sendRestaurantAttributesApiRequest();
      }
    },
    selectedAlcohol: function(){
      if (this.sendRequest) {
        this.sendRestaurantAttributesApiRequest();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.sendRequest = true;
    });
  },

  methods: {
    updateRestaurantAttributes(businessProfile) {
      this.businessProfile = businessProfile;
      this.businessProfile.Alcohol == true ? this.selected.push("Alcohol") : "";
      this.businessProfile.Banquet == true ? this.selected.push("Banquet") : "";
      this.businessProfile.Breakfast == true
        ? this.selected.push("Breakfast")
        : "";
      this.businessProfile.Brunch == true ? this.selected.push("Brunch") : "";
      this.businessProfile.Catering == true
        ? this.selected.push("Catering")
        : "";
      this.businessProfile.Delivery == true
        ? this.selected.push("Delivery")
        : "";
      this.businessProfile.Dinner == true ? this.selected.push("Dinner") : "";
      this.businessProfile.HappyHours == true
        ? this.selected.push("HappyHours")
        : "";
      this.businessProfile.HasTV == true ? this.selected.push("HasTV") : "";
      this.businessProfile.FreeParking == true ? this.selected.push("FreeParking") : "";
      this.businessProfile.Lunch == true ? this.selected.push("Lunch") : "";
      this.businessProfile.OutdoorSeating == true
        ? this.selected.push("OutdoorSeating")
        : "";
      this.businessProfile.Snack == true ? this.selected.push("Snack") : "";
      this.businessProfile.TakeOut == true ? this.selected.push("TakeOut") : "";
      this.businessProfile.TakeReservations == true
        ? this.selected.push("TakeReservations")
        : "";
      this.businessProfile.WiFi == true ? this.selected.push("WiFi") : "";

      this.businessProfile.FullBar == true ? this.selectedAlcohol = "FullBar"
        : 
        'BeerAndWineOnly';
    },

    sendRestaurantAttributesApiRequest(selected) {
      // this.businessProfile =  this.businessProfileGetter;

      this.businessProfile.Alcohol = this.selected.includes("Alcohol")
        ? true
        : false;
      this.businessProfile.BYOB = this.selected.includes("BYOB") ? true : false;
      this.businessProfile.Banquet = this.selected.includes("Banquet")
        ? true
        : false;
      this.businessProfile.Breakfast = this.selected.includes("Breakfast")
        ? true
        : false;

      this.businessProfile.Brunch = this.selected.includes("Brunch")
        ? true
        : false;
      this.businessProfile.Catering = this.selected.includes("Catering")
        ? true
        : false;
      this.businessProfile.Delivery = this.selected.includes("Delivery")
        ? true
        : false;
      this.businessProfile.Dinner = this.selected.includes("Dinner")
        ? true
        : false;

      this.selectedAlcohol == "FullBar"
        ? (this.businessProfile.FullBar = true, this.businessProfile.BeerAndWineOnly = false )
        : (this.businessProfile.FullBar =  false, this.businessProfile.BeerAndWineOnly = true);

      this.businessProfile.HappyHours = this.selected.includes("HappyHours")
        ? true
        : false;
      this.businessProfile.HasTV = this.selected.includes("HasTV")
        ? true
        : false;
      this.businessProfile.FreeParking = this.selected.includes("FreeParking")
        ? true
        : false;
      this.businessProfile.Lunch = this.selected.includes("Lunch")
        ? true
        : false;
      this.businessProfile.OutdoorSeating = this.selected.includes(
        "OutdoorSeating"
      )
        ? true
        : false;
      this.businessProfile.Snack = this.selected.includes("Snack")
        ? true
        : false;
      this.businessProfile.TakeOut = this.selected.includes("TakeOut")
        ? true
        : false;
      this.businessProfile.TakeReservations = this.selected.includes(
        "TakeReservations"
      )
        ? true
        : false;
      this.businessProfile.WiFi = this.selected.includes("WiFi") ? true : false;

      // this.restaurantAttributes
      this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);

      this.$api.getRestaurant
        .UpdateServices(this.businessProfile)
        .then((res) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  font-size: 1.03rem;
}
</style>
